import { Gender } from 'src/common/constants/genders';
import { IParticipant } from './Participant';
import { EAgeGroups } from './Statistics';

export enum ECheckinTimerType {
  start = 'start',
  finish = 'finish',
  clear = 'clear',
};

export interface IBaseCheckin {
  id?: string;
  startTime?: Date;
  finishTime?: Date;
  duration?: number;
}

export type IFormCheckin = IBaseCheckin & {
  competition: string;
  participant: string;
  distance: string;
  edition: string;
  priceOverride?: number;
};

export interface ICheckin extends IBaseCheckin {
  competition: string;
  participant: IParticipant;
  distance: string;
  edition: string;
  id: string;
  ser: number;
  dnf?: boolean;
}

export interface IAnonymizedCheckin {
  age: EAgeGroups;
  city: string;
  country?: string;
  competition: string;
  distance: string;
  duration?: number;
  finishTime?: Date | string | null;
  dnf?: boolean;
  gender: Gender;
  lat?: number | null;
  lng?: number | null;
  name: string;
  price: number;
  ser: number;
  sportsGroupName?: string;
}

export interface IResetCheckin {
  competitionId: string;
  distanceId: string;
  editionId: string;
}

export interface ICheckinTimer {
  id: string;
  type: ECheckinTimerType;
  timeStamp?: Date;
}

export interface IBulkCheckinTimer extends ICheckinTimer {
  distanceId: string;
  editionId: string;
  checkinIds: string[];
}

export enum ECheckinFilters {
  timerStarted = 'timerStarted',
  timerFinished = 'timerFinished',
}